/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { createPhi } from '../../factoriesAny.js';
export var phiDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  createPhi: createPhi
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesPhi.generated.js
// module id = 1474
// module chunks = 0